import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "settings/organization_settings/revenue_categories"
});

export const api = {
  getRevenueCategories(params) {
    return instance.get("", params);
  },
  getActions(params) {
    return instance.get("get_actions_list", params);
  },
  getRevenueCategoryInfo(id, params) {
    return instance.get(`/${id}`, params);
  },
  toggleChallengers(params) {
    return instance.post("/enable_challengers", params);
  },
  getRevenueCategoriesFilters(params) {
    return instance.get("/get_filters", params);
  },
  toggleTags(params) {
    return instance.post("/toggle_tag", params);
  },
  importRevenueCategories(params) {
    return instance.post("/import", params);
  },
  exportRevenueCategories(params) {
    return instance.post("/export", params);
  },
  removeEmptyRevenueCategories(params) {
    return instance.post("/remove_empty_revenue_categories", params);
  },
  recalculateMemberships(params) {
    return instance.post("/recalculate_memberships", params);
  },
  recalculateValues(params) {
    return instance.post("/recalculate_values", params);
  },
  resetMapping(params) {
    return instance.post("/reset_mapping", params);
  }
};
